// extracted by mini-css-extract-plugin
export var aircallIframe = "_eg-3";
export var fabContainer = "_eg-5";
export var fabRinging = "_eg-6";
export var loadingOverlay = "_eg-4";
export var pulse = "_eg-7";
export var widgetContent = "_eg-2";
export var widgetPanel = "_eg-0";
export var widgetPanelExpanded = "_eg-1";